import { useGetTourServices } from '~/hooks/apis/tours/useTourCostPrices';
import { useGetTourOffer, useGetTourOfferSummary } from '~/hooks/apis/tours/useTourOffers';

import { hedgePaxByConfiguration } from '../TourDetails/SlidingScale/slidingScaleRows';

/**
 * RM's hedge pax for each of the tour's configurations, from the tour the bundle's LTLE is built on, and
 * the primary supplier's configurations for listing options in the tour's order.
 */
export default function useTourHedgePax(tourOfferId: string | undefined) {
  const { data: offer, error: offerError } = useGetTourOffer(tourOfferId);
  const baseTourOfferId = offer
    ? (offer.services.find((service) => service.linkedTourOfferId)?.linkedTourOfferId ?? offer.id)
    : undefined;
  const { data: base, error: baseError } = useGetTourOfferSummary(baseTourOfferId);
  const { data: services, error: servicesError } = useGetTourServices(base?.legacyTourId ?? undefined);
  // The oldest live supplier service, which svc-tour lists first, is the tour's primary supplier.
  const service = services?.find((item) => !item.linkedTourOfferId && item.configurations.length > 0);

  const hedges = Object.fromEntries(
    Object.entries(hedgePaxByConfiguration(services ?? [])).map(([name, pax]) => [name.toLowerCase(), pax]),
  );

  const error = offerError ?? baseError ?? servicesError;
  return {
    hedgePaxOf: (tourConfiguration: string): number | undefined => hedges[tourConfiguration.toLowerCase()],
    service,
    isLoading: !error && (!offer || !base || (!!base.legacyTourId && !services)),
    error,
  };
}
